import React, { Component } from 'react'
import MenuSider from '../../../../components/MenuSider'
import { Bar, Pie } from 'react-chartjs-2';
import { Checkbox, Button, Spin, Select, Collapse, Divider, message } from 'antd';
import { Constants, Odata_2_Url } from '../../../../Constants/Constants'
import 'chartjs-plugin-labels';
import IntlMessages from '../../../../util/IntlMessages';

const Panel = Collapse.Panel;
const Option = Select.Option;
const axios = require('axios');

function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

const month_list = [{ "monthName": <IntlMessages id='January' />, "order": 1 },
{ "monthName": <IntlMessages id='February' />, "order": 2 },
{ "monthName": <IntlMessages id='March' />, "order": 3 },
{ "monthName": <IntlMessages id='April' />, "order": 4 },
{ "monthName": <IntlMessages id='May' />, "order": 5 },
{ "monthName": <IntlMessages id='June' />, "order": 6 },
{ "monthName": <IntlMessages id='July' />, "order": 7 },
{ "monthName": <IntlMessages id='August' />, "order": 8 },
{ "monthName": <IntlMessages id='September' />, "order": 9 },
{ "monthName": <IntlMessages id='October' />, "order": 10 },
{ "monthName": <IntlMessages id='November' />, "order": 11 },
{ "monthName": <IntlMessages id='December' />, "order": 12 }]


const pieLabel = {
    plugins: {
        labels: {
            render: function (args) {
                return args.label + ', ' + args.value + ', ' + args.percentage + '%';
            },
            fontSize: 14,
            fontStyle: 'bold'
        }
    }
}

const barLabel = {
    showLines: false,
    responsive: true,
    scales: {
        yAxes: [{
            ticks: {
                beginAtZero: true,
            }
        }],
        xAxes: [{
            ticks: {
                // padding: 20,
                autoSkip: false,
                // maxRotation: 90,
                // minRotation: 90,
            },
        }]
    },
    legend: {
        labels: {
            boxWidth: 50,
            fontSize: 10
        }
    },
    plugins: {
        labels: {
            render: 'value'
        }
    }
}

export default class ObserveType extends Component {

    state = {
        onLoading: false,
        hasValue: false,
        chkAll: false,
        select_company: [],
        select_division: [],
        select_department: [],
        select_section: [],
        select_year: new Date().getFullYear(),
        select_month: [new Date().getMonth() + 1],
        CompanyOption: [],
        DivisionOption: [],
        DepartmentOption: [],
        SectionOption: [],
        pieActionData: {},
        pieConditionData: {},
        barActionSafe: {},
        barActionUnsafe: {},
        barConditionSafe: {},
        barConditionUnsafe: {},
        pieLabel: { ...pieLabel },
        barLabel: { ...barLabel }
    }

    componentDidUpdate(prevProps, prevState) {
        let stateEng = JSON.parse(window.localStorage.getItem('state'))
        let isEng = stateEng.setting.locale.locale == 'en'
        if (isEng !== prevState.isEng) {
            this.setState({ isEng: isEng })
            let data = this.state.data
            this.setPieActionData(data.action.safe, data.action.unsafe)
            this.setPieConditionData(data.condition.safe, data.condition.unsafe)
            this.setBarData('Action', 'Safe', data.actionSafe)
            this.setBarData('Action', 'Unsafe', data.actionUnsafe)
            this.setBarData('Condition', 'Safe', data.conditionSafe)
            this.setBarData('Condition', 'Unsafe', data.conditionUnsafe)
        }
    }

    componentWillMount() {
        let state = JSON.parse(window.localStorage.getItem('state'))
        let isEng = state.setting.locale.locale == 'en'
        this.setState({ isEng: isEng })
        this.prepareDropdown();
    }

    prepareDropdown() {
        let userInfo = JSON.parse(window.localStorage.getItem('User_Info'))
        let departmentId = userInfo.DepartmentID

        this.getToken().then(token => {

            let tokenHeader = {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            };

            axios.get(Constants.BASE_URL + 'api/Master/GetDepartmentById?DepartmentID=' + departmentId, tokenHeader).then(res => {
                this.setState({
                    select_department: [res.data.department]
                })
            })

            axios.get(Constants.BASE_URL + 'api/Master/GetCompany', tokenHeader).then(res => {
                let option = []
                res.data.map(l => {
                    option.push(<Option value={l.company_Code} key={l.company_Code}>{l.company_Name}</Option>)
                })
                this.setState({
                    CompanyOption: option
                })
            })

            axios.get(Constants.BASE_URL + 'api/Master/GetDivision', tokenHeader).then(res => {
                let option = []
                res.data.map(l => {
                    option.push(<Option value={l.value} key={l.value}>{l.text}</Option>)
                })
                this.setState({
                    DivisionOption: option
                })
            })

            axios.get(Constants.BASE_URL + 'api/Master/GetDepartment', tokenHeader).then(res => {
                let option = []
                res.data.map(l => {
                    option.push(<Option value={l.value} key={l.value}>{l.text}</Option>)
                })
                this.setState({
                    DepartmentOption: option
                })
            })

            axios.get(Constants.BASE_URL + 'api/Master/GetSection', tokenHeader).then(res => {
                let option = []
                res.data.map(l => {
                    option.push(<Option value={l.value} key={l.value}>{l.text}</Option>)
                })
                this.setState({
                    SectionOption: option
                })
            })
        });
    }

    setPieActionData(safe, unsafe) {
        this.setState({
            pieActionData: {
                labels: this.state.isEng ? ['Safe', 'Unsafe'] : ['ปลอดภัย', 'ไม่ปลอดภัย'],
                datasets: [{
                    data: [safe, unsafe],
                    showInLegend: true,
                    backgroundColor: [
                        'rgba(75,220,150,0.5)',
                        'rgba(255,99,132,0.5)',

                    ],
                    borderColor: [
                        'rgba(75,220,150,1)',
                        'rgba(255,99,132,1)',

                    ],
                    borderWidth: 0.2
                }]
            }
        })
    }

    setPieConditionData(safe, unsafe) {
        this.setState({
            pieConditionData: {
                labels: this.state.isEng ? ['Safe', 'Unsafe'] : ['ปลอดภัย', 'ไม่ปลอดภัย'],
                datasets: [{
                    data: [safe, unsafe],
                    showInLegend: true,
                    backgroundColor: [
                        'rgba(75,220,150,0.5)',
                        'rgba(255,99,132,0.5)',

                    ],
                    borderColor: [
                        'rgba(75,220,150,1)',
                        'rgba(255,99,132,1)',

                    ],
                    borderWidth: 0.2
                }]
            }
        })
    }

    setBarData(ActionType, SafeType, data) {
        var Category = JSON.parse(window.localStorage.getItem('Category'))
        let CategoryName = data.map(l => {
            return this.state.isEng ? (Category.find(x => x.Category_Name.trim() === l.categoryName) || {}).Category_Name_EN : l.categoryName
        })
        this.setState({
            ['bar' + ActionType + SafeType]:
            {
                labels: CategoryName.map(x => x.split(/ – | /)).filter(x => x !== ''),
                datasets: [
                    {
                        label: 'Number Of ' + SafeType,
                        backgroundColor: SafeType === 'Safe' ? 'rgba(75,220,150,0.2)' : 'rgba(255,99,132,0.2)',
                        borderColor: SafeType === 'Safe' ? 'rgba(75,220,150,1)' : 'rgba(255,99,132,1)',
                        borderWidth: 1,
                        data: data.map(x => x.time)
                    }
                ]
            }
        })
    }

    loadData = (e) => {
        this.setState({ onLoading: true });
        let params = {
            Year: this.state.select_year,
            Month: this.state.select_month,
            Company: this.state.select_company,
            Division: this.state.select_division,
            Department: this.state.select_department,
            Section: this.state.select_section
        }

        this.getToken().then(token => {

            let tokenHeader = {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            };

            axios.post(Constants.BASE_URL + 'api/dashboard/GetObservationCategoryDetail', params, tokenHeader).then(res => {
                let data = res.data
                this.setPieActionData(data.action.safe, data.action.unsafe)
                this.setPieConditionData(data.condition.safe, data.condition.unsafe)
                this.setBarData('Action', 'Safe', data.actionSafe)
                this.setBarData('Action', 'Unsafe', data.actionUnsafe)
                this.setBarData('Condition', 'Safe', data.conditionSafe)
                this.setBarData('Condition', 'Unsafe', data.conditionUnsafe)
                this.setState({ onLoading: false, hasValue: true, data: data });
            }, error => {
                this.setState({ onLoading: false, hasValue: false })
                message.error("Something went wrong please try again. Message is " + error)
                return
            })
        });

        

    }

    exportData = (e) => {

    }

    getToken() {
        var $getToken = new Promise((resolve, reject) => {
            axios.get(Constants.BASE_URL + 'auth/token').then((res) => {
                resolve(res.data);
            }).catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {
        var min = "2018"
        var max = new Date().getFullYear()
        var options = []
        for (var i = min; i <= max; i++) {
            options.push(<Option value={i} key={i}>{i}</Option>)
        }

        let month_options = []
        month_list.map((l, i) => {
            month_options.push(<Option value={l.order} key={l.order}>{l.monthName}</Option>)
        })

        return (
            <div>
                <Spin spinning={this.state.onLoading} size="large" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }} tip={<IntlMessages id='Loading' />}>
                    <MenuSider title={<IntlMessages id='menu.Observation_type_report' />}>
                        <div style={{ width: "100%", padding: "10px 20px 0 20px", textAlign: "center" }}>
                            <Collapse defaultActiveKey={['1']}>
                                <Panel header={<IntlMessages id='Filter' />} key="1">
                                    <div style={{ width: "100%", padding: "5px 20px 0 20px", textAlign: "center" }}>
                                        <div>
                                            <div className='row'>
                                                <div style={{ display: 'inline-block' }}>
                                                    <Select
                                                        style={{ width: 190, margin: "10px 0px 10px 5px" }}
                                                        placeholder="Select company"
                                                        mode="multiple"
                                                        onChange={e => { this.setState({ select_company: e }) }}
                                                        filterOption={(input, option) =>
                                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                    >
                                                        {this.state.CompanyOption}
                                                    </Select>
                                                    <Select
                                                        style={{ width: 190, margin: "10px 0px 10px 5px" }}
                                                        placeholder="Select division"
                                                        mode="multiple"
                                                        onChange={e => { this.setState({ select_division: e }) }}
                                                        filterOption={(input, option) =>
                                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                    >
                                                        {this.state.DivisionOption}
                                                    </Select>
                                                    <Select
                                                        style={{ width: 190, margin: "10px 0px 10px 5px" }}
                                                        placeholder="Select department"
                                                        mode="multiple"
                                                        onChange={e => { this.setState({ select_department: e }) }}
                                                        value={this.state.select_department}
                                                        filterOption={(input, option) =>
                                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                    >
                                                        {this.state.DepartmentOption}
                                                    </Select>
                                                    <Select
                                                        style={{ width: 190, margin: "10px 0px 10px 5px" }}
                                                        placeholder="Select section"
                                                        mode="multiple"
                                                        onChange={e => { this.setState({ select_section: e }) }}
                                                        filterOption={(input, option) =>
                                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                    >
                                                        {this.state.SectionOption}
                                                    </Select>
                                                    <Select
                                                        style={{ width: 190, margin: "10px 0px 10px 5px" }}
                                                        placeholder="Select months"
                                                        mode="multiple"
                                                        onChange={e => { this.setState({ select_month: e }) }} defaultValue={this.state.select_month}
                                                        filterOption={(input, option) =>
                                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                    >
                                                        {month_options}
                                                    </Select>
                                                    <Select style={{ width: 100, margin: "10px 5px 10px 5px" }} placeholder="Select a year"
                                                        onChange={e => { this.setState({ select_year: e }) }} defaultValue={max}>
                                                        {options}
                                                    </Select>
                                                </div>
                                                <Divider type='vertical' />
                                                <div style={{ display: 'inline-block' }}>
                                                    <Button onClick={this.loadData} style={{ width: 120, margin: "10px 0px 10px 5px" }}><IntlMessages id='Search' /></Button>
                                                    <Button onClick={this.exportData} type='primary' style={{ margin: "10px 0px 10px 5px" }}><IntlMessages id='Export' /></Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Panel>
                            </Collapse>
                        </div>
                    </MenuSider>
                    {
                        !this.state.hasValue && (
                            <div style={{ margin: '20px', textAlign: "center" }}>
                                <span><IntlMessages id='Dashboard.NodataAvailable' /></span>
                            </div>
                        )
                    }
                    {
                        this.state.hasValue && (
                            <div className='col-12'>
                                <div className="col-md-6">
                                    <div className="col-12" style={{ marginBottom: 25 }}>
                                        <p style={{ textAlign: "center", fontSize: "18px", marginTop: "15px" }}>Summary safe unsafe of Action</p>
                                        <Pie style={{ marginTop: "20px" }} data={this.state.pieActionData} options={this.state.pieLabel} />
                                    </div>
                                    <div className='col-md-6' style={{ textAlign: "center", marginBottom: 25 }}>
                                        <p>Top 3 of action observed type were unsafe</p>
                                        <Bar style={{ marginTop: "20px" }} height={250} data={this.state.barActionUnsafe} options={this.state.barLabel} />
                                    </div>
                                    <div className='col-md-6' style={{ textAlign: "center", marginBottom: 25 }}>
                                        <p>Top 3 of action observed type were safe</p>
                                        <Bar style={{ marginTop: "20px" }} height={250} data={this.state.barActionSafe} options={this.state.barLabel} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="col-12" style={{ marginBottom: 25 }}>
                                        <p style={{ textAlign: "center", fontSize: "18px", marginTop: "15px" }}>Summary safe unsafe of Condition</p>
                                        <Pie style={{ marginTop: "20px" }} data={this.state.pieConditionData} options={this.state.pieLabel} />
                                    </div>
                                    <div className='col-md-6' style={{ textAlign: "center", marginBottom: 25 }}>
                                        <p>Top 3 of condition observed type were unsafe</p>
                                        <Bar style={{ marginTop: "20px" }} height={250} data={this.state.barConditionUnsafe} options={this.state.barLabel} />
                                    </div>
                                    <div className='col-md-6' style={{ textAlign: "center", marginBottom: 25 }}>
                                        <p>Top 3 of condition observed type were safe</p>
                                        <Bar style={{ marginTop: "20px" }} height={250} data={this.state.barConditionSafe} options={this.state.barLabel} />
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </Spin>
            </div >
        )


    }
}